module.exports = __webpack_public_path__ + "static/media/financial-growth-analysis.2910d4d7.svg";